__turbopack_context__.v({
  "bodyLine": "ForClubsHero-module-scss-module__DAKMUa__bodyLine",
  "content": "ForClubsHero-module-scss-module__DAKMUa__content",
  "ctaRow": "ForClubsHero-module-scss-module__DAKMUa__ctaRow",
  "eyebrow": "ForClubsHero-module-scss-module__DAKMUa__eyebrow",
  "headline": "ForClubsHero-module-scss-module__DAKMUa__headline",
  "headlineAccent": "ForClubsHero-module-scss-module__DAKMUa__headlineAccent",
  "headlineWhite": "ForClubsHero-module-scss-module__DAKMUa__headlineWhite",
  "howItWorksLink": "ForClubsHero-module-scss-module__DAKMUa__howItWorksLink",
  "howItWorksText": "ForClubsHero-module-scss-module__DAKMUa__howItWorksText",
  "joinCta": "ForClubsHero-module-scss-module__DAKMUa__joinCta",
  "joinCtaArrow": "ForClubsHero-module-scss-module__DAKMUa__joinCtaArrow",
  "joinCtaText": "ForClubsHero-module-scss-module__DAKMUa__joinCtaText",
});
